export default __webpack_public_path__ + "static/media/trash.183fdac3.svg";